export const feeStrings = {
  fee: {
    category: 'Kategorie',
    order: 'Reihenfolge',
    amount: 'Wert',
    text: 'Dokument Text',
    name: 'Name',
    id: 'ID',
    categories: {
      application: 'Neuantrag',
      prolongationOver: 'Verlängerung über 6 Monate',
      prolongationUnder: 'Verlängerung 6 Monate oder weniger',
      applicationAdditional: 'Neuantrag (zusätzlich)',
      erhebungsgrund: 'Erhebungsgrund',
      befreiungsgrund: 'Befreiungsgrund',
      extensionCompany: 'Erweiterung (Transportunternehmen)',
      warWeaponInquiry: 'Anfragen zu Kriegswaffeneigenschaft',
      demilitarisationCertificate: 'Demilitarisierungsbescheinigung',
      lowerLimit: 'Untergrenze 5.000,00 €',
      govCoopProject: 'Regierungsseitiges Gemeinschaftsprojekt',
      authorityOrder: 'Behördlicher Auftrag',
      minorChanges: 'Kleinere Änderungen',
      discretion: 'Ermessen (z.B. lange Bearbeitungszeit)',
      simpleInfo: 'Einfache Auskunft',
      foreignStateAuthorities: 'Staatliche Stellen im Ausland',
      singleCase: 'Einzelfall',
    },
    tokens: {
      additional: 'zusätzlich',
    },
    prolongationVariants: {
      domestic:
        'Verlängerung (Inlandsbeförderung oder Beförderung an EU-/-NATO-/NATO-gleichgestellte Staaten)',
      thirdCountries: 'Verlängerung (Beförderung Drittländer)',
      thirdCountries2: 'Verlängerung (Beförderung in Drittländer)',
      demonstration: 'Verlängerung (Messe-/Vorführbeförderung an Streitkräfte)',
      transit: 'Verlängerung (Durchfuhrbeförderung)',
      transit2: 'Verlängerung (Durchfuhr)',
      security: 'Verlängerung (Sicherungsgenehmigung)',
    },
    applicationFees: {
      transitDomestic:
        'Inlandsbeförderung und Beförderungen in EU-/NATO- und NATO-gleichgestellte Staaten',
      transportThirdCountries: 'Beförderung in Drittländer',
      transportDemonstration:
        'Beförderung zu Messen, Ausstellung und Präsentation bei Streitkräften',
      transit: 'Durchfuhr',
      securityApproval: 'Sicherungsgenehmigung',
    },
    singleCaseFees: {
      longProcessingTime: 'Lange Bearbeitungszeit',
      dossierWithMultipleFees:
        'Vorgang mit mehreren gebührenfähigen Leistungen',
      otherReasons: 'Sonstige Gründe',
    },
  },
  entitySingular: 'Gebühr',
  entityPlural: 'Gebühren',
  messages: {
    deletion: {
      success: (name: string) => `Gebühr "${name}" wurde erfolgreich gelöscht`,
      error: 'Gebühr konnte nicht gelöscht werden',
    },
    update: {
      success: 'Gebühr erfolgreich aktualisiert',
      error: 'Gebühr konnte nicht aktualisiert werden',
    },
    create: {
      success: 'Gebühr erfolgreich erstellt',
      error: 'Gebühr konnte nicht erstellt werden',
    },
  },
};
